import React, { useEffect, useState } from 'react';
import useInitialResume, { useResume } from '../InitialResume/useInitialResume';
import fetchAPI from '../../../utils/fetchAPI';
import { getUser } from '../../../utils/sessionInfo';
import { Box, CircularProgress, Select, MenuItem, Snackbar, Alert } from '@mui/material';
import RowResume from '../InitialResume/RowResume';
import styles from '../InitialResume/styles.module.scss';
import { RecuperarPasswdRecord } from '../../modalRecord';
import { getCookie } from '../../../utils/cookiesUtils';

const META_EXLUSIVA = [100, 110, 120];
const META_MIXTA = [100, 110, 120];
const blackLogo = require('./../assets/black_logo.png');
const goldLogo = require('./../assets/gold_logo.png');

const CAJAS_LIMITES = [
  { cajas: 20, min: 0, max: 16 },
  { cajas: 25, min: 17, max: 21 },
  { cajas: 30, min: 22, max: 25 },
  { cajas: 35, min: 26, max: 29 },
  { cajas: 40, min: 30, max: 37 },
  { cajas: 50, min: 38, max: 46 },
  { cajas: 60, min: 47, max: 55 },
  { cajas: 70, min: 56, max: 64 },
  { cajas: 80, min: 65, max: 73 },
  { cajas: 90, min: 74, max: 82 },
  { cajas: 100, min: 83, max: 91 },
  { cajas: 110, min: 92, max: 100 },
  { cajas: 120, min: 101, max: 109 },
  { cajas: 130, min: 110, max: 118 },
  { cajas: 140, min: 119, max: 127 },
  { cajas: 150, min: 128, max: 136 },
  { cajas: 160, min: 137, max: 145 },
  { cajas: 170, min: 146, max: 154 },
  { cajas: 180, min: 155, max: 163 },
  { cajas: 190, min: 164, max: 172 },
  { cajas: 200, min: 173, max: 188 },
  { cajas: 225, min: 189, max: 210 },
  { cajas: 250, min: 211, max: 232 },
  { cajas: 275, min: 233, max: 254 },
  { cajas: 300, min: 255, max: 276 },
  { cajas: 325, min: 277, max: 299 },
  { cajas: 350, min: 300, max: 321 },
  { cajas: 375, min: 322, max: 345 },
  { cajas: 400, min: 346, max: 370 },
  { cajas: 430, min: 371, max: 400 },
  { cajas: 460, min: 401, max: 430 },
  { cajas: 490, min: 431, max: 450 },
  { cajas: 510, min: 451, max: 485 },
  { cajas: 550, min: 486, max: 530 },
  { cajas: 600, min: 531, max: 575 },
  { cajas: 650, min: 576, max: 620 },
  { cajas: 700, min: 621, max: 670 },
  { cajas: 750, min: 671, max: 720 },
  { cajas: 800, min: 721, max: 765 },
  { cajas: 850, min: 766, max: 810 },
  { cajas: 900, min: 811, max: 870 },
  { cajas: 1000, min: 871, max: 970 },
  { cajas: 1200, min: 971, max: 1150 },
  { cajas: 1400, min: 1151, max: 1350 },
  { cajas: 1600, min: 1351, max: 1550 },
  { cajas: 1800, min: 1551, max: 1720 },
  { cajas: 2000, min: 1721, max: 1930 },
  { cajas: 2250, min: 1931, max: 2150 },
  { cajas: 2500, min: 2151, max: 2400 },
  { cajas: 2750, min: 2401, max: 2650 },
  { cajas: 3000, min: 2651, max: 2850 },
  { cajas: 3250, min: 2851, max: 3100 },
  { cajas: 3500, min: 3101, max: Infinity },
];

function getCajaByAVG(avg) {
  return CAJAS_LIMITES.find((caja) => avg >= caja.min && avg <= caja.max) || CAJAS_LIMITES[0];
}

export function calcularMetas(avgBoxes, porcentaje) {
  return Math.round(avgBoxes * (porcentaje / 100));
}

export const Goals = ({ handleProcess }) => {
  const DATA = useInitialResume();
  const DATA2 = useResume();
  const [USER] = useState(getUser());
  const [metaAvg, setMetaAvg] = useState(0);
  const [inputBoxesAvg, setInputBoxesAvg] = useState(0);
  const [loading, setLoading] = useState(false);
  const [resultExclusiva, setResultExclusiva] = useState([]);
  const [resultMixta, setResultMixta] = useState([]);
  const [activeMetaQuantity, setActiveMetaQuantity] = useState(false);
  const [activeMetaQuantityRecalculate, setActiveMetaQuantityRecalculate] = useState(false);
  const [inputAVGDefault, setInputAVGDefault] = useState(0);
  const [secondStep, setSecondStep] = useState(null);
  const [page, setPage] = useState(1);
  const [visibleModal, setVisibleModal] = useState(false);
  const [successPasswd, setSuccessPasswd] = useState(false);
  const [isPressed1, setIsPressed1] = useState({ active: false, index: null });
  const [isPressed2, setIsPressed2] = useState({ active: false, index: null });
  const [selectUser, setSelectUser] = useState(null);
  const [selectedCaja, setSelectedCaja] = useState(null);
  const [clubLevel, setClubLevel] = useState('B_MAX');

  useEffect(() => {
    try {
      if (selectedCaja) {
        setMetaAvg(selectedCaja);
        setInputBoxesAvg(selectedCaja);
        setResultExclusiva((prev) =>
          META_EXLUSIVA.map((meta) => ({ ...prev, points: calcularMetas(selectedCaja.cajas, meta) }))
        );
        setResultMixta((prev) => META_MIXTA.map((meta) => ({ ...prev, points: calcularMetas(selectedCaja.cajas, meta) })));
      }
    } catch (err) {
      console.error('Error en useEffect selectedCaja:', err);
    }
  }, [selectedCaja]);

  useEffect(() => {
    setLoading(true);
    try {
      const service1 = `v1/MX/customers/boxesAvg`;
      fetchAPI({
        service: service1,
        protocol: 'GET',
        callbackThen: (RESPOND_API) => {
          try {
            if (RESPOND_API?.data) {
              setInputAVGDefault(Number(inputBoxesAvg) || Math.round(RESPOND_API?.data?.boxesAvg));
              setActiveMetaQuantityRecalculate(Boolean(RESPOND_API?.data?.boxesAvg));
            }
            const service2 = `v1/MX/customers/points`;
            fetchAPI({
              service: service2,
              protocol: 'GET',
              callbackThen: (respondGET) => {
                try {
                  setResultExclusiva((prev) =>
                    prev.map((p) => {
                      return { ...p, goal: p.points * (respondGET?.data?.exclusive ?? 0) };
                    })
                  );
                  setResultMixta((prev) =>
                    prev.map((p) => {
                      return { ...p, goal: p.points * (respondGET?.data?.mixed ?? 0) };
                    })
                  );
                  setLoading(false);
                } catch (err) {
                  setLoading(false);
                  console.error('Error en callbackThen points:', err);
                }
              },
              callbackCatch: (e, a) => {
                setLoading(false);
                console.error('Error en fetchAPI points:', e, a);
              },
            });
          } catch (err) {
            setLoading(false);
            console.error('Error en callbackThen boxesAvg:', err);
          }
        },
        callbackCatch: (e, a) => {
          setLoading(false);
          console.error('Error en fetchAPI boxesAvg:', e, a);
        },
      });
    } catch (err) {
      setLoading(false);
      console.error('Error en useEffect fetchAPI:', err);
    }
  }, [USER, inputBoxesAvg]);

  useEffect(() => {
    try {
      setSecondStep(true); // Permitir avanzar siempre
    } catch (err) {
      console.error('Error en useEffect setSecondStep:', err);
    }
  }, [DATA]);

  useEffect(() => {
    try {
      const servicePasswd = `v1/MX/passwd/exist-question`;
      fetchAPI({
        service: servicePasswd,
        protocol: 'POST',
        params: {
          customer_no: USER?.ID,
        },
        callbackThen: (respondGET) => {
          try {
            if (!respondGET.exist) {
              setVisibleModal(true);
            }
          } catch (err) {
            console.error('Error en callbackThen exist-question:', err);
          }
        },
        callbackCatch: (e, a) => {
          console.error({ RECOVERY: e, a });
        },
      });
    } catch (err) {
      console.error('Error en useEffect exist-question:', err);
    }
  }, [USER?.ID]);

  useEffect(() => {
    setLoading(true);
    const cookie = getCookie('userInfoBees');

    if (cookie) {
      setClubLevel(cookie.clubLevel);
      setLoading(false);
    } else {
      try {
        const service1 = `v1/MX/customers/clubLevel`;
        fetchAPI({
          service: service1,
          protocol: 'GET',
          callbackThen: (RESPOND_API) => {
            try {
              console.log(RESPOND_API);
              setClubLevel(RESPOND_API.data.clubLevel);
            } catch (err) {
              setLoading(false);
              console.error('Error en callbackThen boxesAvg:', err);
            }
          },
          callbackCatch: (e, a) => {
            setLoading(false);
            console.error('Error en fetchAPI boxesAvg:', e, a);
          },
        });
      } catch (err) {
        setLoading(false);
        console.error('Error en useEffect fetchAPI:', err);
      }
    }
  }, []);

  const handleChange = (e) => {
    try {
      const value = e.target.value;
      if (/^\d*$/.test(value)) {
        const numericValue = parseInt(value, 10);
        if (!isNaN(numericValue) && numericValue >= 20 && numericValue <= 3500) {
          setMetaAvg(value);
          setActiveMetaQuantity(true);
        } else {
          setActiveMetaQuantity(false);
        }
      } else {
        setActiveMetaQuantity(false);
      }
      if (value === '') {
        setMetaAvg('');
        setActiveMetaQuantity(false);
      }
    } catch (err) {
      console.error('Error en handleChange:', err);
    }
  };

  const onClick = () => {
    try {
      if (Number(metaAvg) >= 20 && Number(metaAvg) <= 3500) {
        setInputBoxesAvg(Number(metaAvg));
        setPage(2);
        setActiveMetaQuantity(false);
      } else {
        alert('NO CUMPLE LA META');
      }
    } catch (err) {
      console.error('Error en onClick:', err);
    }
  };

  const onClickRecalculate = () => {
    try {
      if (Number(metaAvg) >= 20 && Number(metaAvg) <= 3500) {
        setInputBoxesAvg(Number(metaAvg));
        setActiveMetaQuantityRecalculate(false);
        setIsPressed2({ active: false, index: null });
        setIsPressed1({ active: false, index: null });
        setSelectUser(null);
      } else {
        alert('NO CUMPLE LA META');
      }
    } catch (err) {
      console.error('Error en onClickRecalculate:', err);
    }
  };

  const handleChangeRecalculate = (e) => {
    try {
      const value = e.target.value || inputAVGDefault;
      if (/^\d*$/.test(value)) {
        const numericValue = parseInt(value, 10);
        if (!isNaN(numericValue) && numericValue >= 20 && numericValue <= 3500) {
          setMetaAvg(value);
          setActiveMetaQuantityRecalculate(true);
        } else {
          setActiveMetaQuantityRecalculate(false);
        }
      } else {
        setActiveMetaQuantityRecalculate(false);
      }
      if (value === '') {
        setMetaAvg('');
        setActiveMetaQuantityRecalculate(false);
      }
    } catch (err) {
      console.error('Error en handleChangeRecalculate:', err);
    }
  };

  const onClickFn = () => {
    try {
      if (secondStep) {
        setPage(2);
      }
      if (activeMetaQuantity) {
        onClick();
      }
      if (selectUser && page === 2) {
        localStorage.setItem('@selectType', JSON.stringify(selectUser));
        handleProcess({
          protocol: 'PATCH',
          params: {
            transition: 'initial',
            stepData: {
              goalSelected: String(selectUser.points),
              totalpoints: String(selectUser.goal),
              typeGoal: String(selectUser.type),
            },
          },
        });
      }
    } catch (err) {
      console.error('Error en onClickFn:', err);
    }
  };
  let filteredCajas = CAJAS_LIMITES;
  if (DATA?.volumeHistory?.lastMonths) {
    if (DATA2?.stepGoal !== null) {
      let initial = DATA2?.stepGoal?.meta;
      const maxCajas = CAJAS_LIMITES[CAJAS_LIMITES.length - 1].cajas;
      filteredCajas = [];
      if (initial < maxCajas) {
        filteredCajas = CAJAS_LIMITES.filter((option) => option.cajas > initial);
      }
      filteredCajas.unshift({ cajas: initial });
    } else {
      const validPoints = DATA.volumeHistory.lastMonths.filter((m) => m.points !== null).map((m) => m.points);
      const avgPoints = validPoints.length > 0 ? validPoints.reduce((a, b) => a + b, 0) / validPoints.length : 0;
      filteredCajas = CAJAS_LIMITES.filter((option) => option.cajas >= avgPoints);
    }
  } else {
    filteredCajas = [];
  }

  const ClubContent = ({ clubLevel }) => {
    return (
      <>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              color: 'black',
              fontFamily: 'Work Sans',
              fontSize: '17px',
              textAlign: 'center',
              fontWeight: '700',
              marginBottom: 0,
              backgroundImage: 'url(' + blackLogo + ')',
              backgroundPosition: '50% 15px',
              backgroundSize: '45%',
              height: '90px',
              backgroundRepeat: 'no-repeat',
            }}
          >
            Preferente
          </div>

          {resultExclusiva?.map((p, i) => (
            <div
              onClick={() => [
                setIsPressed1({ active: true, index: i }),
                setIsPressed2({ active: false, index: null }),
                setSelectUser({ type: 'exclusivo', ...p }),
              ]}
              key={i}
              style={{
                width: 130,
                height: 120,
                borderRadius: 20,
                backgroundColor: isPressed1.index === i ? '#343434' : 'white',
                color: isPressed1.index === i ? 'white' : 'black',
                marginTop: 2,
                marginBottom: 8,
                transition: 'background-color 0.2s, color 0.2s',
              }}
            >
              <div
                style={{
                  color: isPressed1.index === i ? 'white' : 'black',
                  fontFamily: 'Work Sans',
                  fontSize: '17px',
                  textAlign: 'center',
                  fontWeight: '700',
                  marginTop: 12,
                }}
              >
                Meta
              </div>
              <div
                style={{
                  color: isPressed1.index === i ? 'white' : 'black',
                  fontFamily: 'Work Sans',
                  fontSize: '17px',
                  textAlign: 'center',
                  fontWeight: '500',
                  marginTop: 5,
                }}
              >
                {p?.points}
              </div>
              <div
                style={{
                  color: isPressed1.index === i ? 'white' : 'black',
                  fontFamily: 'Work Sans',
                  fontSize: '17px',
                  textAlign: 'center',
                  fontWeight: '700',
                  marginTop: 12,
                }}
              >
                Puntos
              </div>
              <div
                style={{
                  color: isPressed1.index === i ? 'white' : 'black',
                  fontFamily: 'Work Sans',
                  fontSize: '17px',
                  textAlign: 'center',
                  fontWeight: '500',
                  marginTop: 5,
                }}
              >
                {p?.goal}
              </div>
            </div>
          ))}
        </div>
        {clubLevel === 'B_MAX' && (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                color: 'black',
                fontFamily: 'Work Sans',
                fontSize: '17px',
                textAlign: 'center',
                fontWeight: '700',
                marginBottom: 0,
                backgroundImage: 'url(' + goldLogo + ')',
                backgroundPosition: '58% 20px',
                backgroundSize: '45%',
                height: '90px',
                backgroundRepeat: 'no-repeat',
              }}
            >
              BGold
            </div>
            {resultMixta?.map((p, i) => (
              <div
                onClick={() => [
                  setIsPressed2({ active: true, index: i }),
                  setIsPressed1({ active: false, index: null }),
                  setSelectUser({ type: 'mixto', ...p }),
                ]}
                key={i}
                style={{
                  width: 130,
                  height: 120,
                  borderRadius: 20,
                  backgroundColor: isPressed2.index === i ? '#dbc877' : 'white',
                  color: isPressed2.index === i ? 'black' : 'black',
                  marginTop: 2,
                  marginBottom: 8,
                  transition: 'background-color 0.2s, color 0.2s',
                }}
              >
                <div
                  style={{
                    color: 'black',
                    fontFamily: 'Work Sans',
                    fontSize: '17px',
                    textAlign: 'center',
                    fontWeight: '700',
                    marginTop: 12,
                  }}
                >
                  Meta
                </div>
                <div
                  style={{
                    color: 'black',
                    fontFamily: 'Work Sans',
                    fontSize: '17px',
                    textAlign: 'center',
                    fontWeight: '500',
                    marginTop: 5,
                  }}
                >
                  {p?.points}
                </div>
                <div
                  style={{
                    color: 'black',
                    fontFamily: 'Work Sans',
                    fontSize: '17px',
                    textAlign: 'center',
                    fontWeight: '700',
                    marginTop: 12,
                  }}
                >
                  Puntos
                </div>
                <div
                  style={{
                    color: 'black',
                    fontFamily: 'Work Sans',
                    fontSize: '17px',
                    textAlign: 'center',
                    fontWeight: '500',
                    marginTop: 5,
                  }}
                >
                  {p?.goal}
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  return (
    <div>
      {loading ? (
        <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '50vh',
            }}
          >
            <CircularProgress />
          </Box>
        </>
      ) : (
        <>
          <div
            data-testid="back-button"
            style={{
              position: 'fixed',
              top: '20px',
              left: '20px',
              width: '30vw',
              height: '20px',
              backgroundColor: 'transparent',
              zIndex: 9999,
            }}
            onClick={() => setPage(1)}
          />
          <span
            style={{
              color: 'black',
              fontFamily: 'Work Sans',
              fontSize: ' 20px',
              fontWeight: '800',
              marginLeft: 25,
              marginTop: -20,
            }}
          >
            {page ? 'Meta Inicial' : 'Escoger Meta'}
          </span>
          {page === 1 && (
            <div
              style={{
                width: '80%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto',
              }}
            >
              <div>
                <div className={`${styles.title} ${styles.mb20}`} style={{ marginTop: 25 }}>
                  Venta de cartones
                </div>
                <div className={`${styles.box} ${styles.mb20}`} style={{ width: '100%' }}>
                  {DATA?.volumeHistory?.lastMonths?.map(({ month, points, highlighted }) => (
                    <RowResume
                      key={`${month}-${points}-${highlighted}`}
                      label={month}
                      points={points ?? 0}
                      highlighted={!!highlighted}
                    />
                  ))}
                  {!DATA?.volumeHistory?.lastMonths && (
                    <label className={`maz-tu-info-bees-input__label`}>Usuario sin informacion</label>
                  )}
                </div>
                <div style={{ marginTop: 15, width: '100%' }}>
                  <Select
                    value={selectedCaja?.cajas || ''}
                    onChange={(event) => {
                      const newValue = filteredCajas.find((c) => c.cajas === event.target.value);
                      setSelectedCaja(newValue);
                    }}
                    displayEmpty
                    variant="outlined"
                    style={{ width: 300, marginBottom: 16 }}
                    renderValue={(selected) => (selected ? selected : 'Selecciona meta de cajas')}
                  >
                    <MenuItem value="" disabled>
                      Selecciona meta de cajas
                    </MenuItem>
                    {filteredCajas.map((option) => (
                      <MenuItem key={option.cajas} value={option.cajas}>
                        {option.cajas}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
            </div>
          )}
          {page === 2 && (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-evenly',
                  marginTop: 20,
                }}
              >
                <ClubContent clubLevel={'B_MAX'} />
              </div>
            </>
          )}
          <div
            onClick={() => {
              if ((page === 1 && selectedCaja) || (page === 2 && selectUser)) {
                DATA?.volumeHistory?.lastMonths && onClickFn();
              }
            }}
            style={{
              backgroundColor: (page === 1 && selectedCaja) || (page === 2 && selectUser) 
                ? '#000000' : '#A7A8A9',
              width: '80%',
              padding: 10,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              marginTop: 30,
              borderRadius: 5,
              cursor: (page === 1 && selectedCaja) || (page === 2 && selectUser) ? 'pointer' : 'not-allowed',
              pointerEvents: (page === 1 && selectedCaja) || (page === 2 && selectUser) 
                ? 'auto' : 'none',
            }}
          >
            <div
              style={{
                color: 'white',
                fontFamily: 'Work Sans',
                fontSize: ' 12px',
                textAlign: 'center',
                fontWeight: '700',
              }}
            >
              CONTINUAR
            </div>
          </div>
          {visibleModal && <RecuperarPasswdRecord visible={visibleModal} onClose={(success) => { setVisibleModal(false); if (success) setSuccessPasswd(true); }} />}
          <Snackbar
            open={successPasswd}
            autoHideDuration={3000}
            onClose={() => setSuccessPasswd(false)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert onClose={() => setSuccessPasswd(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
              Contraseña actualizada correctamente
            </Alert>
          </Snackbar>
        </>
      )}
    </div>
  );
};
